import React, { Component, PureComponent } from 'react'
import Link from 'gatsby-link'
import Logo from '../shared/logo'
import IMRD from '../shared/imrd'
import Drawer from './drawer'
import Hamburger from '../shared/hamburger'
import Cross from '../shared/cross'
import './header.css'
import { Mobile, Default, Desktop, Tablet } from '../../media-queries'

export default class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      drawerOpen: false,
      ...this.getHeaderClass(),
    }
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = () => {
    if (!this.state.drawerOpen) {
      let newState = this.getHeaderClass()
      if (this.state.headerClass !== newState.headerClass)
        this.setState({ ...newState })
    }
  }

  closeDrawer = () => {
    this.setState({
      drawerOpen: false,
      ...this.getHeaderClass(),
    })
    this.again()
  }

  toggleDrawer = () => {
    const { drawerOpen } = this.state
    this.setState(prevState => ({
      drawerOpen: !prevState.drawerOpen,
      ...this.getHeaderClass(!prevState.drawerOpen ? 'navOpen' : null),
    }))
    if (drawerOpen) this.again('navOpen')
  }

  again = () => {
    if (typeof window !== 'undefined') {
      window.setTimeout(() => this.setState({ ...this.getHeaderClass() }), 0)
    }
  }

  getHeaderClass = option => {
    if (option === 'navOpen') return navOpen
    else if (option === 'navDefault') return navDefault
    if (
      this.props.isAtRoot &&
      typeof window !== 'undefined' &&
      window.scrollY < 5
    )
      return navDefault
    return navAlt
  }

  render() {
    const { closeDrawer, toggleDrawer } = this
    return (
      <div>
        <Desktop>
          <div id="nav" className={'unselectable'}>
            <DesktopHeader
              drawerOpen={this.state.drawerOpen}
              headerClass={
                this.props.isAtRoot ? this.state.headerClass : 'navAlt'
              }
              color={this.props.isAtRoot ? this.state.color : 'black'}
              fn={{ closeDrawer, toggleDrawer }}
            />
            {this.state.drawerOpen && <Drawer toggle={toggleDrawer} />}
          </div>
        </Desktop>
        <Tablet>
          <div id="nav" className={'unselectable'}>
            <MobileHeader
              drawerOpen={this.state.drawerOpen}
              headerClass={this.state.headerClass}
              color={this.state.color}
              fn={{ closeDrawer, toggleDrawer }}
            />
          </div>
        </Tablet>
        <Mobile>
          <div id="nav" className={'unselectable'}>
            <MobileHeader
              drawerOpen={this.state.drawerOpen}
              headerClass={this.state.headerClass}
              color={this.state.color}
              fn={{ closeDrawer, toggleDrawer }}
            />
          </div>
        </Mobile>
      </div>
    )
  }
}

class DesktopHeader extends PureComponent {
  render() {
    const { fn, headerClass, color, drawerOpen } = this.props
    return (
      <div className={headerClass} style={{ padding: '0 2em' }}>
        <div id="header">
          <Link className="brand" to="/" onClick={fn.closeDrawer}>
            <Logo style={{ height: '95%' }} color={color} />
            <IMRD
              style={{ height: '55%', marginLeft: '.75em' }}
              color={color}
            />
          </Link>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              fontWeight: 700,
              fontSize: '18px',
            }}
          >
            <Link
              style={{ marginRight: '3vw' }}
              to="/programme"
              onClick={fn.closeDrawer}
            >
              <div className={headerClass} style={{ background: 'none' }}>
                Programme
              </div>
            </Link>
            <Link
              style={{ marginLeft: '3vw', marginRight: '3vw' }}
              to="/application"
              onClick={fn.closeDrawer}
            >
              <div className={headerClass} style={{ background: 'none' }}>
                Application
              </div>
            </Link>
            <Link
              style={{ marginLeft: '3vw' }}
              to="/tuition-and-scholarships"
              onClick={fn.closeDrawer}
            >
              <div className={headerClass} style={{ background: 'none' }}>
                Tuition &amp; Scholarships
              </div>
            </Link>
          </div>
          {drawerIcon(drawerOpen, fn.toggleDrawer, color, '55%')}
        </div>
      </div>
    )
  }
}

class TabletHeader extends PureComponent {
  render() {
    const { fn, headerClass, color, drawerOpen } = this.props
    return (
      <div className={headerClass} style={{ padding: '0 1em' }}>
        <div id="header">
          <Link className="brand" to="/" onClick={fn.closeDrawer}>
            <Logo style={{ height: '80%' }} color={color} />
            <IMRD
              style={{ height: '45%', marginLeft: '.75em' }}
              color={color}
            />
          </Link>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              fontWeight: 700,
              fontSize: '20px',
            }}
          >
            <Link
              style={{ marginRight: '1.5vw' }}
              to="/programme"
              onClick={fn.closeDrawer}
            >
              <div className={headerClass} style={{ background: 'none' }}>
                Programme
              </div>
            </Link>
            <Link
              style={{ marginLeft: '1.5vw', marginRight: '1.5vw' }}
              to="/application"
              onClick={fn.closeDrawer}
            >
              <div className={headerClass} style={{ background: 'none' }}>
                Application
              </div>
            </Link>
            <Link
              style={{ marginLeft: '1.5vw' }}
              to="/tuition-and-scholarships"
              onClick={fn.closeDrawer}
            >
              <div className={headerClass} style={{ background: 'none' }}>
                Tuition &amp; Scholarships
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

class MobileHeader extends PureComponent {
  render() {
    const { fn, headerClass, color, drawerOpen } = this.props
    return (
      <div>
        <div className={headerClass}>
          <div id="header">
            <Link className="brand" to="/" onClick={fn.closeDrawer}>
              <Logo style={{ height: '80%' }} color={color} />
              <IMRD
                style={{ height: '45%', marginLeft: '.5rem' }}
                color={color}
              />
            </Link>
            {drawerIcon(drawerOpen, fn.toggleDrawer, color)}
          </div>
          {drawerOpen && <Drawer toggle={fn.toggleDrawer} />}
        </div>
        {drawerOpen && (
          <div className="bottomPadding">
            <span onClick={fn.toggleDrawer}>Close</span>
          </div>
        )}
      </div>
    )
  }
}

const navAlt = {
  headerClass: 'navAlt',
  color: 'black',
}
const navDefault = {
  headerClass: 'navDefault',
  color: 'white',
}
const navOpen = {
  headerClass: 'navOpen',
  color: 'black',
}

const drawerIcon = (drawerOpen, toggleDrawer, color, height = '45%') => {
  return drawerOpen ? (
    <Cross
      style={{ height, width: '25px', cursor: 'pointer' }}
      onClick={toggleDrawer}
      color={color}
    />
  ) : (
    <Hamburger
      style={{ height, width: '25px', cursor: 'pointer' }}
      onClick={toggleDrawer}
      color={color}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/header.js